module.exports = __webpack_public_path__ + "static/media/Waylon Smithers.91e076d6.png";